import { getProduct } from '../../../helpers/products';
import IdentifiersIcon from '../../../components/icons/IdentifiersIcon';
import PhoneIcon from '../../../components/icons/PhoneIcon';
import IPIcon from '../../../components/icons/IPIcon';
import IdentifiersBundleIcon from '../../../components/icons/IdentifiersBundleIcon';
import DigitalUsageIcon from '../../../components/icons/DigitalUsageIcon';

export type AddOn = {
  header: string;
  body: string;
  iconComponent: React.FC;
  productKey: string;
  topCaption?: string;
  recordsAvailableFn: (orderDetails: any) => number;
  enabled?: boolean; // defaults to true if not specified
};

export type Tab = {
  label: string;
  addOns: AddOn[];
};

const tabs: Tab[] = [
  {
    label: 'Identifiers',
    addOns: [
      {
        header: 'Email',
        body: 'Personalization and segmentation made possible with 13 core demographic elements.',
        iconComponent: IdentifiersIcon,
        productKey: 'emailAddOn',
        recordsAvailableFn: ({ emailsIncluded }) => emailsIncluded,
        enabled: false, // Temporarily disabled - email data not currently available
      },
      {
        header: 'IP Address',
        body: 'Personalization and segmentation made possible with 13 core demographic elements.',
        iconComponent: IPIcon,
        productKey: 'ipAddOn',
        recordsAvailableFn: ({ ipsIncluded }) => ipsIncluded,
      },
      {
        header: 'Phone',
        body: 'Personalization and segmentation made possible with 13 core demographic elements.',
        iconComponent: PhoneIcon,
        productKey: 'phoneAddOn',
        recordsAvailableFn: ({ phonesIncluded }) => phonesIncluded,
      },
      {
        header: 'Bundle Deal',
        body: 'Get the essential cross-channel identifiers.',
        iconComponent: IdentifiersBundleIcon,
        productKey: 'identifierBundleAddOn',
        topCaption: '68% Savings',
        recordsAvailableFn: ({ emailsIncluded, ipsIncluded, phonesIncluded }) =>
          Math.max(emailsIncluded, ipsIncluded, phonesIncluded),
      },
    ],
  },
  {
    label: 'More',
    addOns: [
      {
        header: 'Digital Usage',
        body: 'License your audience for unlimited digital targeting use',
        iconComponent: DigitalUsageIcon,
        productKey: 'digitalUseAddOn',
        recordsAvailableFn: ({ recordsIncluded }) => recordsIncluded,
      },
    ],
  },
];

export default tabs;

export const identifierAddOnIds = ['emailAddOn', 'phoneAddOn', 'ipAddOn'].map(
  (productKey) => getProduct(productKey)?.id
);
